module.exports = __webpack_public_path__ + "media/images/steps/step_15-480b4f322cd3892d816d4f7eaff6a608.svg";